import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from "rxjs";
import {CompetitionImportRow} from "../../../shared/interface/competition-import-row";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {
  EditDialogCompetitionImportRowComponent
} from "../edit-dialog-competition-import-row/edit-dialog-competition-import-row.component";
import {AuthService} from "../../../shared/services/auth.service";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CompetitionImportService} from "../../../shared/services/competition-import.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";

@Component({
  selector: 'app-edit-competition-import-row',
  templateUrl: './edit-competition-import-row.component.html',
  styleUrls: ['./edit-competition-import-row.component.scss']
})
export class EditCompetitionImportRowComponent implements OnInit {

  @Input() importRow: Observable<CompetitionImportRow>;
  @Output() closeModification = new EventEmitter<void>();
  @Input() dialogRef?: MatDialogRef<EditDialogCompetitionImportRowComponent>;

  importRowForm: FormGroup;
  processingRequest = false;
  userPermissions: ReplaySubject<UserPermissions>;
  importRowObject: CompetitionImportRow;

  importRowProductControl: FormControl;
  amountControl: FormControl;
  typeControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  ofwcaDataControl: FormControl;
  partnerDataControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private formHelper: FormHelperService,
    private competitionService: CompetitionImportService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.userPermissions = this.auth.getUserPermissions();
    this.importRowForm = fb.group({
      warehouseProduct: this.importRowProductControl = fb.control(''),
      amount: this.amountControl = fb.control(''),
      type: this.typeControl = fb.control('', [Validators.required]),
      ofwca: this.ofwcaControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
    });
    this.ofwcaDataControl = fb.control('');
    this.partnerDataControl = fb.control('');
  }

  ngOnInit(): void {
    if (this.importRow) {
      this.importRow
        .pipe(takeUntil(this.destroyed$))
        .subscribe((importRowObject: CompetitionImportRow) => {
          this.importRowObject = importRowObject;
          this.initialize(importRowObject);
        });
    }

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((type: string) => {
        if (type === 'partner') {
          this.ofwcaControl.reset();
        } else if (type === 'ofwca') {
          this.partnerControl.reset();
        }
      });
  }

  initialize(importRowObject: CompetitionImportRow): void {
    of(importRowObject)
      .pipe(
        delay(0),
        tap(() => {
          const type = importRowObject?.ofwca ? 'ofwca'
            : importRowObject?.partner ? 'partner'
              : null;

          this.importRowForm.reset({
            warehouseProduct: importRowObject?.warehouseProduct?.uuid ?? null,
            amount: importRowObject?.amount ?? null,
            ofwca: importRowObject?.ofwca?.uuid ?? null,
            partner: importRowObject?.partner?.uuid ?? null,
          });
          this.typeControl.setValue(type);

          this.initialized.next(true);
        })
      ).subscribe();
  }

  save(): void {
    this.processingRequest = true;
    this.competitionService.editImportRow(
      this.importRowForm.getRawValue(),
      this.importRowObject ? this.importRowObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.importRowObject ? 'Pomyślnie zaktualizowano' : 'Pomyślnie utworzono licencję', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.importRow) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/wyniki-konkursow/wyniki/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.closeModification.emit();
    }
  }

}
